<template>
  <div>
    <div data-v-58174b0f="" class="clearfix"></div>
    <transition name="formErrors">
      <div
        v-if="form.errors.length > 0"
        class="alert alert-danger"
      >
        Please correct the following errors:<br>
        (If the Unique Identifier is missing, you may consider duplicating a field such as a SKU number which is unique to the item)
        <br>
        <ul>
          <li v-for="(error, index) in form.errors" :key="index">{{error.message}}</li>
        </ul>
      </div>
    </transition>
    <input
      ref="csv"
      type="file"
      name="csv"
      class="form-control client-form-control"
      @change="parseCsv">
    <br>
    <div class="alert alert-success" v-if="form.csv !== null">
      CSV successfully uploaded
    </div>
    <!-- <div
      v-if="form.csv !== null"
      class="preview">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th v-for="(header, index) in form.csvHeaders" :key="index">{{ header.displayName }}</th>
            </tr>
          </thead>
          <tbody class="table-striped">
            <tr v-for="(row, index) in form.csv" :key="index">
              <td v-for="(col, dataIndex) in form.csvHeaders" :key="`${index}-${dataIndex}`">{{ row[col.field] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
  </div>
</template>

<script>
import Papa from 'papaparse'
import _ from 'lodash'

export default {
  name: 'CsvImporter',
  props: {
    hasHeaders: {
      type: Boolean,
      default () {
        return true
      }
    },
    requiredFields: {
      required: true
    },
    csvErrors: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      csv: null,
      headers: [],
      form: {
        errors: [],
        csvHeaders: [],
        csv: null
      }
    }
  },
  methods: {
    parseCsv () {
      const _this = this
      _this.form.errors = []
      this.readFile((output) => {
        _this.csv = _.get(Papa.parse(output, { skipEmptyLines: true }), 'data')
        _this.emitForm(_this.csv)
      })
    },
    readFile (callback) {
      let file = this.$refs.csv.files[0]
      if (file) {
        let reader = new FileReader()
        reader.readAsText(file, 'UTF-8')
        reader.onload = function (evt) {
          callback(evt.target.result)
        }
        reader.onerror = function () {
        }
      }
    },
    emitCsv (csv) {
      this.form.csv = this.buildMappedCsv(csv)
      this.$emit('input', this.form.csv)
    },
    emitForm (csv) {
      this.form.csv = this.buildMappedCsv(csv)
      this.$emit('input', this.form)
    },
    setupHeaders (headerArr) {
      const camelHeaders = headerArr.map(header => _.camelCase(header))
      this.form.csvHeaders = headerArr.map(header => {
        return { field: _.camelCase(header), displayName: header }
      })
      return camelHeaders
    },
    formatMissingFieldsError (fieldsArr) {
      return fieldsArr
        .map(field => {
          return field
            .match(/[A-Za-z][a-z]*/g)
            .map(word => word.charAt(0).toUpperCase() + word.substring(1))
            .join(' ')
        }).join(', ')
    },
    buildMappedCsv (parsedCsv) {
      const _this = this
      const headersToMap = _this.setupHeaders(_this.csv.slice(0, 1)[0]) // take headers to create custom fields
      const missingFields = _this.requiredFields.filter(field => !headersToMap.includes(field)) // get list of required fields that aren't included
      if (missingFields.length > 0) {
        _this.form.errors.push({ message: `Missing fields: ${this.formatMissingFieldsError(missingFields)}` })
      }
      // TODO: return error to acknowledge the missing fields
      let csv = this.hasHeaders ? _.drop(this.csv) : this.csv
      return _.map(csv, (row) => {
        let newRow = {}
        headersToMap.forEach((field, idx) => { // this mapFields is going to change...using required fields for the common ones
          _.set(newRow, field, row[idx])
        })
        return newRow
      })
    },
    toReadable (word) {
      let words = word.match(/[A-Za-z][a-z]*/g) || []
      return words.map(word => {
        return word.charAt(0).toUpperCase() + word.substring(1)
      }).join(' ')
    }
  }
}
</script>
